import { QUESTION_SET_LAST, QUESTION_GO_BACK } from '../actions'

function PrevIntroQuestionsReducer(state = [], action) {
    switch (action.type) {
        case QUESTION_SET_LAST:
            return [...state, action.payload]
        case QUESTION_GO_BACK:
            return state.slice(0, -1)
        default:
            return state
    }
}

export default PrevIntroQuestionsReducer



// WEBPACK FOOTER //
// ./src/reducers/prevIntroQuestion.js